import { Box, styled } from "@mui/material";

export const AccessControlWrapper = styled(Box)(({ theme }) => {
    return {
        "& .title-box": {
            overflow: "hidden",
            flex: 1,
        },
        "& fieldset": {
            overflow: "hidden",
        },
        "& .module": {
            overflow: "hidden",
            padding: "var(--basic-padding) 0 0",
            marginBlockEnd: "var(--basic-margin)",
            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
        },
        "& .module-header": {
            padding: "0 var(--basic-padding) var(--basic-padding)",
            cursor: "pointer",
            "& svg": {
                color: "#791377"
            }
        },
        "& .button-box": {
            overflow: "hidden",
            marginBlockStart: "calc(var(--basic-margin) * 2)",
            marginBlockEnd: "calc(var(--basic-margin) * 1)",
            "& button": {
                width: "100%",
                [theme.breakpoints.up("miniTablet")]: {
                    width: "auto",
                }
            }
        },
    }
})